export const TEMPLATE_ENVIRONMENT_PAGE = {
  REQUEST_FOR_APPROVAL_BUTTON: {
    key: 'REQUEST_FOR_APPROVAL_BUTTON',
    value: 'Request for approval',
  },
  PUBLISH_BUTTON: { key: 'PUBLISH_BUTTON', value: 'Publish' },
  NOT_YET_PUBLISHED_LABEL: { key: 'NOT_YET_PUBLISHED_LABEL', value: 'Not yet published' },
  TIME_NOT_AVAILABLE_LABEL: { key: 'TIME_NOT_AVAILABLE_LABEL', value: 'Not available' },
  TEMPLATE_SEND_FOR_APPROVAL_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_SEND_FOR_APPROVAL_SUCCESS_MESSAGE',
    value: 'Template sent for approval',
  },
  TEMPLATE_PUBLISHED_SUCCESS_MESSAGE: {
    key: 'TEMPLATE_PUBLISHED_SUCCESS_MESSAGE',
    value: 'Template published',
  },
  PUBLISHED_ENV_TAB: { key: 'PUBLISHED_ENV_TAB', value: 'Published' },
  TESTING_ENV_TAB: { key: 'TESTING_ENV_TAB', value: 'Testing' },
  DRAFT_ENV_TAB: { key: 'DRAFT_ENV_TAB', value: 'Draft' },
  PUBLISHED_SUCCESSFULLY_MESSAGE: { key: 'PUBLISHED_SUCCESSFULLY_MESSAGE', value: '{{type}} is successfully published' },
  SENT_TO_APPROVAL_MESSAGE: { key: 'SENT_TO_APPROVAL_MESSAGE', value: '{{type}} sent for approval!!' },
  UNABLE_TO_PROCESS_ERROR_MESSAGE: { key: 'UNABLE_TO_PROCESS_ERROR_MESSAGE', value: 'Sorry, we are unable to process this operation. Please try again after some time' },
  DOCUMENT_NOT_SENT_FOR_TESTING: { key: 'DOCUMENT_NOT_SENT_FOR_TESTING', value: 'Document is not yet sent for testing' },
  DOCUMENT_NOT_YET_PUBLISHED: { key: 'DOCUMENT_NOT_YET_PUBLISHED', value: 'Document is not yet published' },
  EMAIL_NOT_SENT_FOR_TESTING: { key: 'EMAIL_NOT_SENT_FOR_TESTING', value: 'Email is not yet sent for testing' },
  EMAIL_NOT_YET_PUBLISHED: { key: 'DOCUMENT_NOT_YET_PUBLISHED', value: 'Email is not yet published' },
};
